import { AvatarAssetReference } from '../collection-screen/collection-screen.state';

export interface ICollection_V1 {
  collectionType: string;
}

export interface CollectionBaseReference {
  organizationId: string;
  reference: string;
}

export interface CollectionBaseReferencesWithName
  extends CollectionBaseReference {
  name: string;
  id: string;
}

export interface CollectionAccessoryReference extends CollectionBaseReference {
  position: 'TOP' | 'BOTTOM' | 'MIDDLE';
}

export interface CollectionAvatarReference
  extends CollectionBaseReferencesWithName,
    AvatarAssetReference {}

export interface CollectionSceneReference
  extends CollectionBaseReferencesWithName {}

export interface CollectionGarmentReference
  extends CollectionBaseReferencesWithName {
  garmentLink?: string;
  price?: CollectionPrice;
}

export interface CollectionPrice {
  currency: string;
  price: number;
}

export interface CollectionInfo {
  imageUrl: string;
  name: string;
}

export interface CollectionOutfit {
  id: string;
  scene: CollectionBaseReference;
  avatar: CollectionBaseReference;
  preview: CollectionBaseReference;
  garments: CollectionBaseReference[];
  accessories: CollectionAccessoryReference[];
}

export interface CollectionShoeOption {
  name: string;
  image: string;
  translationKey: string;
}
export interface CollectionSettings {
  shoeOptions?: CollectionShoeOption[];
}

export interface ICollection {
  info: CollectionInfo;
  settings?: CollectionSettings;
  outfits: CollectionOutfit[];
  avatars?: CollectionAvatarReference[];
  scenes?: CollectionSceneReference[];
  garments?: CollectionGarmentReference[];
}

export interface ExtendedCollection {
  id: string;
  schema: string;
  type: string;
  externalReferences: string[];
  collection: ICollection;
}
